import { useState, useEffect, useRef } from "react";
import "./challenge-questions.css";
import { useNavigate } from "react-router-dom";
import ASSETS from "../../../../app/config/assets";
import Button from "../../../../ui/atoms/buttons/Button";
import { BsCheck2Circle, BsUiChecksGrid } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import { FaPercent, FaRegQuestionCircle } from "react-icons/fa";
import { GoClock } from "react-icons/go";
import AdmittedImg from "../../../../assets/images/admitted.svg";
import FailedImg from "../../../../assets/images/failed.svg";
import LeaderBoard from "../../../../ui/organisms/leaderborad/LeaderBoard";
//
import moment from "moment";
import Swal from "sweetalert2";
import { isEmpty, convertDuration, wait } from "../../../../core/utils/helpers";
//
import {
  onGetAdmissionTestCurrentQuestion,
  onAnsweringAdmissionTestCurrentQuestion,
} from "../../../student/services/classTest";
import {
  onAnsweringQuizChallengeCurrentQuestion,
  onGetQuizChallengeCurrentQuestion,
} from "../../services/challenge";
import { useDispatch } from "react-redux";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
import useLogout from "../../../../app/providers/context-provider/useLogout";

const ChallengeQuestion = ({
  assessmentId,
  assessmentMode,
  assessmentType,
  playerRequestId,
  setQuestionTiming,
  setIsQuestionStarted,
  setIsQuestionStopped,
  setPointsGain,
  setTotalPoints,
  setActualQuestion,
  setTotalQuestions,
  responseTiming,
  currentTimerTiming,
  isSkipped,
  setIsSkipped,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const logout = useLogout();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isAT = assessmentMode?.toLowerCase() === "at";
  const isCH = assessmentMode?.toLowerCase() === "ch";
  const [view, setView] = useState("");
  //
  const [isFetching, setIsFetching] = useState(true); // True as initial value allow fetching the first question
  const [isStarted, setIsStarted] = useState(false); // false as initial value
  const [isRunning, setIsRunning] = useState(true); // Running for progress bar
  const [progress, setProgress] = useState(0); // Progress bar initial
  //
  const [scoresBoard, setScoresBoard] = useState([]); // scoresBoard/leaderboard
  //
  const [currentQuestion, setCurrentQuestion] = useState(); // current question
  const [currentQuestionNumber, setCurrentQuestionNumber] = useState(0); // current question
  const [totalQuestionNumber, setTotalQuestionNumber] = useState(0); // current question
  const [isCurrentQuestionStoped, setIsCurrentQuestionStoped] = useState(false); // the current question is responded(stopped the timer)
  //
  const [expectedGoodAnswers, setExpectedGoodAnswers] = useState([]); // the defined good answers of the question
  const [clickedIndexes, setClickedIndexes] = useState([]); // the choosen index-answers by the student
  const [clickedAnswers, setClickedAnswers] = useState([]); // the choosen answers by the student

  const [isAssessCompleted, setIsAssessCompleted] = useState(false);

  const [_pointsWon, setPointsWon] = useState(0); // the points won after answering current question

  const hasMounted = useRef(false);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    if (isFetching) {
      if (isAT) {
        const localData = {
          class_test_id: assessmentId,
          dates: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        };
        onGetAdmissionTestCurrentQuestion(axiosPrivate, localData, signal)
          .then((response) => {
            const question = response?.data?.result;
            const _is_completed = response?.data?.is_completed;
            setCurrentQuestion(question);
            setIsAssessCompleted(_is_completed);
            if (!_is_completed) {
              setView("preload");
            }
            //
            // setup correct answers
            const correctAnswers = question?.answers?.filter(
              (item) => item.is_correct === true,
            );
            //
            setExpectedGoodAnswers(correctAnswers);
            //
            if (question?.timing && typeof setQuestionTiming === "function") {
              setQuestionTiming(parseInt(question?.timing));
              setPointsGain(question?.current_gained_points);
              setTotalPoints(question?.total_points);
              setActualQuestion(question?.current_question);
              setTotalQuestions(question?.total_questions);
              setCurrentQuestionNumber(question?.current_question);
              setTotalQuestionNumber(question?.total_questions);
            }
            setIsFetching(false);
          })
          .catch((error) => {
            if (error?.response?.status === 500) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Internal Server Error. Please try again later.",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.detail?.message,
              });
            }
          });
      }
      if (isCH) {
        const localData = {
          challenge_id: assessmentId,
          request_id: playerRequestId,
        };
        onGetQuizChallengeCurrentQuestion(axiosPrivate, localData, signal)
          .then((response) => {
            const _data = response?.data?.result;
            const is_completed = response?.data?.is_completed;
            const question = _data?.current_question;
            const challenge_total_points = _data?.challenge_total_points;
            const total_points_won = _data?.total_points_won;
            const question_number = _data?.current_question_number;
            const total_questions = _data?.total_questions;
            //
            setScoresBoard({
              scores: _data?.scoreboard,
              report: _data?.report,
            });
            setCurrentQuestion(question);
            setIsAssessCompleted(is_completed);
            setView("scoreboard");
            //
            // setup correct answers
            const correctAnswers = question?.answers?.filter(
              (item) => item.is_correct === true,
            );
            //
            setExpectedGoodAnswers(correctAnswers);
            //
            if (question?.timing && typeof setQuestionTiming === "function") {
              setQuestionTiming(parseInt(question?.timing));
              //
              setPointsGain(total_points_won);
              setTotalPoints(challenge_total_points);
              setCurrentQuestionNumber(question_number);
              setTotalQuestionNumber(total_questions);
              //
              // informations to display on header (x Questions left over y)
              setActualQuestion(question_number);
              setTotalQuestions(total_questions);
            }
            setIsFetching(false);
          })
          .catch((error) => {
            if (error?.response?.status === 500) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Internal Server Error. Please try again later.",
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.detail?.message,
              });
            }
          });
      }
    }
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isFetching]);

  useEffect(() => {
    if (isCurrentQuestionStoped && responseTiming === 0) {
      setIsStarted(false);
      setProgress(0);
      setIsRunning(true);
    }
  }, [isCurrentQuestionStoped]);

  // on timer over
  useEffect(() => {
    if (view === "preload" && !isAssessCompleted) {
      if (progress < 100 && isRunning) {
        setTimeout(() => setProgress((prev) => (prev += 2)), 50);
      }
      if (progress === 100) {
        setView("question");
        setIsStarted(true);
        setIsQuestionStarted(true);
        setIsRunning(false);
      }
    }
  }, [progress, isRunning, view]);

  const totalAnswers = expectedGoodAnswers?.length;

  useEffect(() => {
    if (currentTimerTiming === 0) {
      const val = Math.abs(
        expectedGoodAnswers?.length - clickedIndexes?.length,
      );
      for (let i = 0; i < val; i++) {
        setClickedIndexes((prev) => [...prev, expectedGoodAnswers?.length + 1]);
        setClickedAnswers((prev) => [
          ...prev,
          {
            answer: "is skipped",
            is_correct: false,
          },
        ]);
      }
    }
  }, [currentTimerTiming]);

  // on skipped question by user
  useEffect(() => {
    if (isSkipped) {
      setClickedIndexes([]);
      setClickedAnswers([]);
      //
      for (let i = 0; i < expectedGoodAnswers?.length; i++) {
        setClickedIndexes((prev) => [...prev, expectedGoodAnswers?.length + 1]);
        setClickedAnswers((prev) => [
          ...prev,
          {
            answer: "is skipped",
            is_correct: false,
          },
        ]);
      }
    }
  }, [isSkipped]);

  // on user answered
  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return; // ignore la première exécution
    }

    if (clickedIndexes.length === totalAnswers && totalAnswers > 0) {
      setIsQuestionStopped(true);
      //
      const _dates = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      const _local_id = currentQuestion?.id;
      const _timing = Math.abs(
        parseInt(currentQuestion?.timing) - parseInt(currentTimerTiming),
      );
      //
      // Function to count correct answers from 'answers' that match with 'data'
      const countCorrectMatches = () => {
        return clickedAnswers.filter((ans) => {
          return (
            ans.is_correct === true &&
            expectedGoodAnswers.some(
              (d) => d.answer === ans.answer && d.is_correct === true,
            )
          );
        }).length;
      };
      //
      const _points = Math.round(
        (currentQuestion?.points / totalAnswers) * countCorrectMatches(),
      );
      setPointsWon(_points);
      //
      if (isAT) {
        const localData = {
          dates: _dates,
          id: _local_id,
          answers: JSON.stringify(clickedAnswers),
          timing: _timing,
          points: parseFloat(_points),
        };
        onAnsweringAdmissionTestCurrentQuestion(axiosPrivate, localData);
      }
      if (isCH) {
        const localData = {
          dates: _dates,
          answers: JSON.stringify(clickedAnswers),
          timing: _timing,
          points: _points,
          join_challenge_id: playerRequestId,
          challenge_details_id: _local_id,
        };

        onAnsweringQuizChallengeCurrentQuestion(axiosPrivate, localData);
      }
    }
  }, [clickedIndexes, totalAnswers]);

  useEffect(() => {}, [scoresBoard]);

  const onAnswer = (idx) => {
    if (clickedIndexes.length === totalAnswers && totalAnswers > 0) return;
    if (clickedIndexes.includes(idx)) return;
    setClickedIndexes((prev) => [...prev, idx]);
    setClickedAnswers((prev) => [
      ...prev,
      {
        answer: currentQuestion?.answers[idx]?.answer,
        is_correct: currentQuestion?.answers[idx]?.is_correct,
      },
    ]);
  };

  const onHandleLogout = async () => {
    Swal.fire({
      title: '<span style="font-size:1rem; color:grey;">Deconnexion...</span>',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,

      didOpen: () => {
        Swal.showLoading();
      },
    });
    // attendre 1.5 sec
    await wait(1500);
    //
    dispatch(
      challengeSlice?.actions?.setCurrentAssessment({
        mode: null,
        admission_test_id: null,
        challenge_id: null,
        challenge_type: null,
        teams_breakdown: null,
        teams_device: null,
        request_id: null,
      }),
    );

    // logout
    logout();

    // fermer swal si nécessaire
    Swal.close();
  };

  return (
    <div className="challenge-questions">
      {!isEmpty(currentQuestion) && view === "question" && (
        <>
          <div className="ch-q-container mb-md">
            <div className="ruban">
              <img
                src={ASSETS?.icon_question_png}
                alt="icon illustartion of question explanation"
                className="tick-img"
              />
              <span>Question Type :</span>
              <span style={{ color: "brown", paddingLeft: "1rem" }}>
                <i>
                  <em>
                    {totalAnswers > 1
                      ? "Multiple Choice Answers"
                      : "Single Choice Answer"}
                  </em>
                </i>
              </span>
              <span style={{ padding: "0 1rem" }}>
                <i>
                  <em>for</em>
                </i>
              </span>
              <span style={{ color: "green" }}>
                <i>
                  <em>{currentQuestion?.points} point.</em>
                </i>
              </span>
            </div>
            {/* Question section */}
            <div className="w-full d-flex align-center ch-q-wrapper pt-xs">
              <div
                className="ch-q-description"
                style={{
                  width:
                    isEmpty(currentQuestion?.cover_audio) &&
                    isEmpty(currentQuestion?.cover_image) &&
                    "100% !important",
                }}
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: currentQuestion?.description,
                  }}
                />
              </div>
              <div
                className="ch-q-assets"
                style={{
                  display:
                    isEmpty(currentQuestion?.cover_audio) &&
                    isEmpty(currentQuestion?.cover_image) &&
                    "none !important",
                }}
              >
                {currentQuestion?.cover_audio && (
                  <div className="asset-audio">
                    <audio
                      className="w-full"
                      controls
                      controlsList="nodownload"
                      onContextMenu={(e) => e.preventDefault()}
                    >
                      <source
                        src={`${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/audios/${currentQuestion?.cover_audio}`}
                        type={currentQuestion?.cover_audio?.type}
                      />
                    </audio>
                  </div>
                )}
                {currentQuestion?.cover_image && (
                  <div className="asset-img" style={{ textAlign: "center" }}>
                    <img
                      src={`${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/${currentQuestion?.cover_image}`}
                      alt="cover question illustration"
                      style={{ maxWidth: "100%" }}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* end Question section */}
          </div>
          <div className="answers-container mb-md">
            {currentQuestion?.answers?.map((answer, idx) => {
              const wasClicked = clickedIndexes.includes(idx);
              const isCorrect = answer.is_correct;

              return (
                <div
                  className={
                    wasClicked
                      ? isCorrect
                        ? "answer-item is-good is-selected"
                        : "answer-item is-wrong is-selected"
                      : "answer-item"
                  }
                  key={idx}
                  onClick={() => !isCurrentQuestionStoped && onAnswer(idx)}
                >
                  <div className="answer-item-head">
                    <span className="number-label">{idx + 1}</span>
                    {wasClicked ? (
                      isCorrect ? (
                        <BsCheck2Circle className="icon" />
                      ) : (
                        <SlClose className="icon" />
                      )
                    ) : (
                      <></>
                    )}
                    <span>
                      {wasClicked
                        ? isCorrect
                          ? "Correct Answer"
                          : "Wrong Answer"
                        : ""}
                    </span>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: answer?.answer,
                    }}
                  />
                </div>
              );
            })}
          </div>
          {clickedIndexes?.length === expectedGoodAnswers?.length && (
            <>
              <div className="ch-q-container mb-md fade-in">
                <div className="ruban">
                  <img
                    src={ASSETS?.icon_brain_light_gif}
                    alt="icon illustartion of question explanation"
                    className="tick-img"
                  />
                  <span>Explanations</span>
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: currentQuestion?.explanations,
                  }}
                />
              </div>
              <div className="ch-q-container mb-md fade-in">
                <div className="ruban">
                  <img
                    src={ASSETS?.icon_success_gif}
                    alt="icon illustartion of question explanation"
                    className="tick-img"
                  />
                  <span>Correction</span>
                </div>
                <div className="answers-container p-xs">
                  {expectedGoodAnswers?.map((answer, idx) => {
                    return (
                      <div className={"answer-item is-good"} key={idx}>
                        {answer?.is_correct ? (
                          <span>
                            <BsCheck2Circle className="icon" />
                          </span>
                        ) : (
                          <span>
                            <SlClose className="icon" />
                          </span>
                        )}
                        <p
                          dangerouslySetInnerHTML={{
                            __html: answer?.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className="w-full d-flex flex-col align-center justify-center p-md">
                  <p>
                    Total points won :{" "}
                    <i>
                      <em>{_pointsWon} points.</em>
                    </i>
                  </p>
                  <Button
                    type={"button"}
                    preferedStyle={"normal"}
                    title={"Got It, Go to Next question!"}
                    action={() => {
                      setExpectedGoodAnswers([]);
                      setClickedIndexes([]);
                      setClickedAnswers([]);
                      setQuestionTiming(0);
                      setIsCurrentQuestionStoped(false);
                      setProgress(0);
                      setIsRunning(true);
                      setIsStarted(false);
                      setIsQuestionStopped(false);
                      setIsQuestionStarted(false);
                      setIsSkipped(false);
                      setIsFetching(true);

                      if (isAT) {
                        setView("preload");
                      }
                      if (isCH) {
                        setView("scoreboard");
                      }
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
      {/* Preload Question View */}
      <div
        className={
          view === "preload"
            ? "question-preloader slide-in"
            : "question-preloader slide-out"
        }
      >
        <div className="question-preloader-wrapper">
          <BsUiChecksGrid className="preview-icon" />
          <span className="preview-count">
            {currentQuestionNumber} of {totalQuestionNumber}
          </span>
          <div className="preview-question">
            <p
              dangerouslySetInnerHTML={{
                __html: currentQuestion?.description,
              }}
            />
          </div>
          <div className="preview-progress">
            <div
              className="progress-bar"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      </div>
      {/* Admission Report View */}
      <div
        className={
          isAT && isAssessCompleted
            ? "admission-report slide-in"
            : "admission-report slide-out"
        }
      >
        <div className="admission-report-wrapper">
          {(
            (currentQuestion?.current_gained_points /
              currentQuestion?.total_points) *
            100
          ).toFixed(2) >= 50 ? (
            <img
              src={AdmittedImg}
              alt="success illustration"
              className="a-t-img"
            />
          ) : (
            <img
              src={FailedImg}
              alt="failed illustration"
              className="a-t-img"
            />
          )}
          {(
            (currentQuestion?.current_gained_points /
              currentQuestion?.total_points) *
            100
          ).toFixed(2) >= 50 ? (
            <h1>Well done! You succeed the AT and you are admitted.</h1>
          ) : (
            <h1>
              Sorry! You miss the Admission Test with a score wich is not enough to get
              Admitted to the stream you wish.
            </h1>
          )}
          <div className="ad-rep-ruban">
            <div className="ad-rep-ruban-tile">
              <FaPercent className="icon" />
              <div className="col">
                <span>Success rate</span>
                <h1>
                  {(
                    (currentQuestion?.current_gained_points /
                      currentQuestion?.total_points) *
                    100
                  ).toFixed(2)}
                  %
                </h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Questions</span>
                <h1>{currentQuestion?.questions?.length}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <GoClock className="icon" />
              <div className="col">
                <span>Duration</span>
                <h1>{convertDuration(currentQuestion?.duration)}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Success Questions</span>
                <h1>{currentQuestion?.success_questions}</h1>
              </div>
            </div>
            <div className="ad-rep-ruban-tile">
              <FaRegQuestionCircle className="icon" />
              <div className="col">
                <span>Total Missed Questions</span>
                <h1>{currentQuestion?.failed_questions}</h1>
              </div>
            </div>
          </div>
          <div className="ad-rep-questions">
            {currentQuestion?.questions?.map((row, idx) => {
              return (
                <div className="ad-rep-question-item" key={idx}>
                  <div className="row">
                    <span>Question {idx + 1}</span>
                    <span>
                      {row?.type === "OCA"
                        ? "Single Choice Answer"
                        : "Multiple Choice Answers"}
                    </span>
                    <span>
                      {row?.question_won_points} points earned over{" "}
                      {row?.question_total_points} Points
                    </span>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: row?.description,
                    }}
                  />
                  <div className="row-tick">
                    <span className="tick-label">Explanations</span>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: row?.explanations,
                    }}
                  />
                  <div className="row-tick">
                    <span className="tick-label">
                      Initials and Expected reponses
                    </span>
                  </div>
                  <div className="responses-wrapper">
                    {row?.initial_answers?.map((element, j) => {
                      return (
                        <div
                          className={`response-item ${
                            element?.is_correct ? "is-good" : "is-wrong"
                          }`}
                          key={j}
                        >
                          {element?.is_correct ? (
                            <BsCheck2Circle className="icon" />
                          ) : (
                            <SlClose className="icon" />
                          )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: element?.answer,
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="row-tick">
                    <span className="tick-label">Your responses</span>
                  </div>
                  <div className="responses-wrapper">
                    {row?.responded_answers?.map((el, k) => {
                      return (
                        <div
                          className={`response-item ${
                            el?.is_correct ? "is-good" : "is-wrong"
                          }`}
                          key={k}
                        >
                          {el?.is_correct ? (
                            <BsCheck2Circle className="icon" />
                          ) : (
                            <SlClose className="icon" />
                          )}
                          <p
                            dangerouslySetInnerHTML={{
                              __html: el?.answer,
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="p-md">
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Close Admission Test Report and Sign In again!"}
              action={() => onHandleLogout()}
            />
          </div>
        </div>
      </div>
      {/* Preview ScoresBoard */}
      <div
        className={
          view === "scoreboard"
            ? "question-preloader slide-in"
            : "question-preloader slide-out"
        }
      >
        <LeaderBoard
          is_completed={isAssessCompleted}
          data={scoresBoard}
          challenge_type={assessmentType}
          setView={setView}
        />
      </div>
    </div>
  );
};

export default ChallengeQuestion;
